import axios, { AxiosInstance } from "axios";

const BASE_URL = window.MLBBest.envVariables.BASE_URL;
const BASE_API_PATH = window.MLBBest.envVariables.BASE_API_PATH;

const NonAuthClient: AxiosInstance = axios.create({
  headers: {
    Accept: "*/*",
  },
  baseURL: BASE_URL + BASE_API_PATH,
  withCredentials: true,
});

export default NonAuthClient;
